import { render } from "./MasterLayout.vue?vue&type=template&id=f6f410f6&scoped=true"
import script from "./MasterLayout.vue?vue&type=script&lang=js"
export * from "./MasterLayout.vue?vue&type=script&lang=js"

import "./MasterLayout.vue?vue&type=style&index=0&id=f6f410f6&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f410f6"]])

export default __exports__